export default __webpack_public_path__ + "static/media/logo1.21213bdd.jpeg";